export default "__VITE_ASSET__DFaL$Ur3__"